import { protectedRoutes } from "./lib/routes/protected";
import { publicRoutes } from "./lib/routes/public";

const routes = [...publicRoutes, ...protectedRoutes];

export { routes };
